import { render, staticRenderFns } from "./ProjectInitialsButton.vue?vue&type=template&id=ed459e30&scoped=true"
import script from "./ProjectInitialsButton.vue?vue&type=script&lang=js"
export * from "./ProjectInitialsButton.vue?vue&type=script&lang=js"
import style0 from "./ProjectInitialsButton.vue?vue&type=style&index=0&id=ed459e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed459e30",
  null
  
)

export default component.exports